import {createLazyFileRoute} from '@tanstack/react-router'

import ContactUs from '@/views/ContactUs/ContactUs'

export const Route = createLazyFileRoute('/contact-us')({
  component: ContactUs,
})
